import React, { useState } from "react"
import Downloads from "../../images/banner-04@2x.png"
import "./downloads.sass"
import { DownloadBtns } from "../../components/download-btn"
import { defaultIntl, isAu } from "../../utils"

export default ({ intl = defaultIntl }) => {
  return (
    <div className="downloads" id="downloadApp">
      <div className="container">
        <div className="columns">
          <div className="column is-half-desktop">
            <div className="banner_img">
              <img src={Downloads} alt="" />
            </div>
          </div>
          <div className="column is-half-desktop">
            <div className="text-content">
              <h2>{intl.formatMessage({ id: "index.download.title" })}</h2>
              <p>{intl.formatMessage({ id: isAu() ? "index.download.desc_au" : "index.download.desc" })}</p>
              <DownloadBtns />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
